(() => {
  if (window.pslLocalizationBarReady) return;
  window.pslLocalizationBarReady = true;

  const bars = () => document.querySelectorAll('[data-psl-localization-bar]');
  const initialize = (root = document) => {
    root.querySelectorAll('[data-psl-country-flag]').forEach((element) => {
      const code = element.dataset.pslCountryFlag.toUpperCase();
      if (/^[A-Z]{2}$/.test(code)) {
        element.textContent = String.fromCodePoint(...Array.from(code, (letter) => 127397 + letter.charCodeAt(0)));
      }
    });
    root.querySelectorAll('.psl-localization-bar__picker').forEach((picker) => {
      if (picker.dataset.pslReady) return;
      picker.dataset.pslReady = 'true';
      picker.addEventListener('toggle', () => {
        if (picker.open) {
          picker.closest('[data-psl-localization-bar]').querySelectorAll('details[open]').forEach((other) => {
            if (other !== picker) other.open = false;
          });
        }
        const header = picker.closest('.header-wrapper');
        if (header) header.preventHide = Boolean(header.querySelector('.psl-localization-bar__picker[open]'));
      });
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.psl-localization-bar__form')) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    const submitter = event.submitter;
    if (returnTo) {
      const destination = new URL(window.location.href);
      if (submitter?.name === 'country_code') destination.searchParams.delete('country');
      returnTo.value = destination.pathname + destination.search + destination.hash;
    }
  });

  document.addEventListener('click', (event) => {
    bars().forEach((bar) => {
      if (!bar.contains(event.target)) bar.querySelectorAll('details[open]').forEach((picker) => { picker.open = false; });
    });
  });

  document.addEventListener('keydown', (event) => {
    const picker = event.target.closest('.psl-localization-bar__picker');
    if (!picker) return;
    if (event.key === 'Escape' && picker.open) {
      event.preventDefault();
      picker.open = false;
      picker.querySelector('summary').focus();
    }
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && picker.open) {
      const options = Array.from(picker.querySelectorAll('.psl-localization-bar__option'));
      const current = options.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown' ? (current + 1) % options.length : current < 0 ? options.length - 1 : (current - 1 + options.length) % options.length;
      if (options[next]) {
        event.preventDefault();
        options[next].focus();
      }
    }
  });

  document.addEventListener('focusin', (event) => {
    bars().forEach((bar) => {
      bar.querySelectorAll('details[open]').forEach((picker) => {
        if (!picker.contains(event.target)) picker.open = false;
      });
    });
  });

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
